interface IValidationFields {
  [key: string]: string;
}

const validateForm = (validation: IValidationFields, form_values: any) => {
  let object = {};

  Object.keys(validation).forEach(element => {
    const [type, valor] = validation[element].split('|');

    if (type === 'required' && !form_values[element]) {
      object = {
        ...object,
        [element]: 'Campo obrigatório.'
      }
    }

    if (type === 'min' && (!form_values[element] || form_values[element].length < parseInt(valor))) {
      object = {
        ...object,
        [element]: `O campo precisa ter ao menos ${valor} caracteres.`
      }
    }

    if (type === 'min_number' && form_values[element] <= valor) {
      object = {
        ...object,
        [element]: `O campo precisa ser maior que ${valor}.`
      }
    }
  });

  if (Object.keys(object).length === 0) {
    return {};
  }

  return object;
}

export default validateForm;